// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Belt_Id = require("bs-platform/lib/js/belt_Id.js");
var Caml_obj = require("bs-platform/lib/js/caml_obj.js");
var FormalityCompat__FormWithId = require("./FormalityCompat__FormWithId.bs.js");

function Make(Form) {
  var cmp = Caml_obj.caml_compare;
  var FieldId = Belt_Id.MakeComparable({
        cmp: cmp
      });
  return FormalityCompat__FormWithId.Make({
              validators: Form.validators,
              FieldId: FieldId
            });
}

var Validation;

exports.Validation = Validation;
exports.Make = Make;
/* FormalityCompat__FormWithId Not a pure module */
